export default __webpack_public_path__ + "static/media/feed_fail.3753d48f.mp3";